<template>

	<transition-group 
		name="alert" 
		tag="div"
		enter-active-class="animate__animated animate__fadeIn animate__faster"
		leave-to-class="animate__animated animate__fadeOut animate__faster"
	> 
		<div key="x" class="featherlight" v-if="shouldShow==true" style="display: block;" v-on:click.self="toggleMessenger()">
			<div class="featherlight-content">
				<button class="featherlight-close-icon featherlight-close" aria-label="Close" v-on:click.self="toggleMessenger()">✕</button>
				<section class="popup_content featherlight-inner section" style="max-width: 45rem;">
					<div class="constraint" id="messages_popup">
						<div class="message_area">
							<transition-group 
								tag="div"
								class="new_message_area"
								enter-active-class="animate__animated animate__bounceInUp"
							> 
								<div :key="message.id" v-for="(message, key) in new_messages" :class="[message.who == 'HW' ? 'them' : 'me', 'message']"><small><b>{{ message.who }}</b> - {{ message.formatted_message_date }}</small><span v-html="formatMessage(message.message)"></span></div>
							</transition-group>
							<div v-for="message in initial_messages" :class="[message.who == 'HW' ? 'them' : 'me', 'message']">
								<span class="new" v-if="message.unread_messages.length == 0">New</span>
								<small><b>{{ message.who }}</b> - {{ message.formatted_message_date }}</small>
								<span v-html="formatMessage(message.message)"></span>
								
							</div>
						</div>
						<div class="message_form form_style">
							<template v-if="errors != [] && errors != null && Object.keys(errors).length > 0">
								<p class="error"><i class="fas fa-2x fa-exclamation-circle"></i> <span>{{ errors.message[0] }}</span></p>
							</template>
							<p>
								<textarea name="message" placeholder="Type your message here" v-model="message"></textarea>
								<button type="submit" class="button solid arrow medium" :class="{spinner : saving}" v-on:click="submitMessage()">Send</button>
							</p>
							<p><small>Please note, your messages are visible to your whole group.<br>You will receive an email when a reply is posted.<br>This is not a live chat. Responses usually within 24 hours.</small></p>
						</div>
					</div>
				</section>

			</div>
		</div>
	 </transition-group>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {
	
	props: [
	],

	data: () => {
		return {
			csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
			uuid: '',
			initial_messages: [],
			new_messages: [],
			message: '',
			errors: [],
			shouldShow: false,
			saving: false,
		}
	},

	computed: {
	},

	watch: {
	},

	created() {
	},

	mounted() {
	},

	methods: {

		...mapActions(['addAlert']),

		wrap: function(el, wrapper) {
			el.parentNode.insertBefore(wrapper, el);
			wrapper.appendChild(el);
		},

		toggleMessenger: function(uuid = null){
			if(this.shouldShow==true) {
				this.uuid = null;
				this.shouldShow = false;
				this.message = '';
				this.errors = [];
				this.initial_messages = [];
				this.new_messages = [];
			}else{
				this.uuid = uuid
				this.shouldShow = true;

				this.$nextTick(function() {
					this.getMessages();
				});
			}
		},

		getMessages: function() {
			axios.post('/ajax/getMessages', {
				uuid: this.uuid
			})
			.then(response => {
				this.initial_messages = response.data;
				$('#messages_' + this.uuid).find('span').remove();
				$('.button.messenger').attr('data-unread', 0);


			})
			.catch(error => {
				var errors = error.response.data['errors'];
				this.errors = errors;
				// document.getElementById('messages_popup').scrollIntoView({behavior: "smooth"});
			});
		},

		formatMessage: function (message) {
			return message.replace(/\n/g, "<br>");
		},

		submitMessage: function() {
			// basic validation
			var message = this.message.trim();
			if(message == '' || this.saving == true) {
				return false;
			}

			this.saving=true;

			axios.post('/ajax/postMessage', {
				uuid: this.uuid,
				message: message
			})
			.then(response => {
				if(response.data['success']) {
					this.errors = [];
					this.message = '';
					var new_message = response.data['success'];
					this.new_messages = [new_message, ...this.new_messages]
					setTimeout(function(){
						var element = $('#messages_popup .message_area')[0];
						element.scroll({ top: element.scrollHeight });
					}, 100);
					this.saving=false;
					$('#messages_' + this.uuid).find('span').remove();
					$('#messages_'+this.uuid).prepend('<div class="message ' + (new_message.who=='HW' ? 'them' : 'me') + '"><small><b>' + new_message.who +'</b> - ' + new_message.formatted_message_date + '</small>' + new_message.message +'</div>');
				}else{
					this.saving=false;
					this.errors = response.data['errors'];
					// document.getElementById('messages_popup').scrollIntoView({behavior: "smooth"});
				}
			})
			.catch(error => {
				this.saving=false;
				var errors = error.response.data['errors'];
				this.errors = errors;
				// document.getElementById('messages_popup').scrollIntoView({behavior: "smooth"});
			});
			
		},

		alert: function(message, type, important = false) {
			this.addAlert({
				alertClass: 'alert-' + type, 
				alertMessage: message, 
				alertImportant: important,
			});
		},

	}
};
</script>